import React, { Component } from 'react';

import { createContainer } from '@dbk-legacy/muster/react';
import { FormattedMessage } from '@dbk-legacy/format';

import { LoadingCircle } from '../../../components/common/loading';
import BlurModal from '../../../components/common/blur-modal';

import { TextInput } from '@dbk/ui-forms';
import Text, { H1 } from '@dbk/ui-text';
import { NotificationWarning } from '@dbk/ui-icons';
import Button from '@dbk/ui-buttons';
import Modal from '@dbk/ui-modal';
import { PALETTE } from '../../../constants';

class ManageSepaTransactionLimit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      limitValue: this.props.sepaLimit.sepaTransactionLimit,
      isCancelModalVisible: false,
    };
  }


  componentDidMount = async () => {
    await this.props.sepaLimit.getSepaIpLimit();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.sepaLimit.sepaTransactionLimit !== this.props.sepaLimit.sepaTransactionLimit &&
      this.state.limitValue == null
    ) {
      this.setState({ limitValue: this.props.sepaLimit.sepaTransactionLimit });
    }

    if (
      prevProps.sepaLimit.isSepaLimitOtpVerified !== this.props.sepaLimit.isSepaLimitOtpVerified &&
      this.props.sepaLimit.isSepaLimitOtpVerified
    ) {
      this.handleOtpVerified();
    }
  }

  handleOtpVerified = async () => {
    const { changePage, sepaLimit: { saveSepaIpLimit, resetOtpState } } = this.props;
    const { limitValue } = this.state;
    const normalizedLimitValue = limitValue == null ? '' : String(limitValue).trim();
    const saveResult = await saveSepaIpLimit(Number(normalizedLimitValue));
    const isSaved = saveResult === true || saveResult?.response === true;

    await resetOtpState();

    if (isSaved) {
      changePage('/profile/manage-sepa-transaction-limit-success');
    }
  }

  handleCancel = () => {
    this.setState({ isCancelModalVisible: true });
  }

  handleCloseCancelModal = () => {
    this.setState({ isCancelModalVisible: false });
  }

  handleConfirmCancel = () => {
    this.setState(
      {
        limitValue: this.props.sepaLimit.sepaTransactionLimit,
        isCancelModalVisible: false,
      },
      () => this.props.changePage('/profile/portfolio')
    );
  }

  handleLimitChange = (event) => {
    this.setState({ limitValue: event.target.value });
  }

  handleConfirm = () => {
    const { sepaLimit: { startOtpVerification } } = this.props;

    startOtpVerification();
  }

  handleCloseErrorModal = async () => {
    const { changePage, sepaLimit: { setBlurModalError } } = this.props;

    await setBlurModalError(null);
    changePage('/profile/portfolio');
  }
 

  render() {
      const { i18n: { messages }, sepaLimit: { blurModalError, maxSepaTransactionLimit } } = this.props;
      const { limitValue, isCancelModalVisible } = this.state;
      const normalizedLimitValue = limitValue == null ? '' : String(limitValue).trim();
      const parsedLimitValue = Number(normalizedLimitValue);
      const parsedMaxLimitValue = Number(maxSepaTransactionLimit);
        const isNegativeLimit = normalizedLimitValue !== '' && parsedLimitValue < 0;
        const isZeroLimit = normalizedLimitValue !== '' && parsedLimitValue === 0;
        const textInputMessages = isNegativeLimit
          ? [{ type: 'error', message: messages['app.sepaip.limit.negative.message'] }]
          : isZeroLimit
          ? [{ type: 'error', message: messages['app.sepaip.limit.zero.message'] }]
          : parsedLimitValue > parsedMaxLimitValue
          ? [{ type: 'error', message: messages['app.sepaip.limit.max.value.error'].replace('{limit}', maxSepaTransactionLimit) }]
          : [];
      const isContinueDisabled =
        normalizedLimitValue === '' ||
        Number.isNaN(parsedLimitValue) ||
        parsedLimitValue <= 0 ||
        parsedLimitValue > parsedMaxLimitValue;

      if (blurModalError !== null) {
        return (
          <BlurModal
            visible={blurModalError !== null}
            doneVisible={false}
            title={messages['app.chedelivery.reports.systemErrorTitle']}
            onDone={this.handleCloseErrorModal}
            className={"model-window-login"}
          >
            <div className="row">
              <div className="small-12 text-center">
                <div className="center">
                  <NotificationWarning color={PALETTE.errorColor} secondaryColor='#152139' width={50} height={50} />
                  <div className="pad-top-25 pad-bottom-25 center">
                    <div className="error-title" tabIndex={0}>
                      <Text numberOfLines={1}>{blurModalError}</Text>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </BlurModal>
        );
      }
        
      return (
        <React.Fragment>
        
          <div className='orderReport'>
            <div className='orderReport__header'>
              <H1 className={"orderReport__heading-title"} tabIndex={0}>{messages['app.sepaip.limit.page.title']}</H1>
                
            </div>
  
  
            <div className='contentContainer'>
              <div className='orderReport__content'>
                  <div className='orderReport__content__field'>
                    <div className="orderReport__content__field--label" tabIndex={0}>
                      <Text primary>{messages['app.sepaip.limit.page.description']}</Text>
                    </div>
                    
                    <div className="orderReport__content__field--dropdown" aria-label={messages['app.reports.accountPortfolioDropdown']}>
                        <TextInput
                        label={messages['app.sepaip.limit.input.label']}
                        textId="input-userId"
                        size={"large"}
                        name="userIdForgot"
                        value={limitValue == null ? '' : String(limitValue)}
                        messages={textInputMessages}
                        onChange={this.handleLimitChange}
                        autoComplete="off"                      
                        zIndex={-1}
                        selectTextOnFocus={false}
                        caretHidden={false}
                        contextMenuHidden={false}
                      />    
                      </div>
                  </div>
                  <div className='orderReport__content__actions'>
                    <Button
                      size='large'
                      tertiary
                      fullWidth={false}
                      onPress={this.handleCancel}
                    >
                      {messages['app.chedelivery.reports.customReports.cancelButton']}
                    </Button>

                    <Button
                      size='large'
                      disabled={isContinueDisabled}
                      onPress={this.handleConfirm}
                      fullWidth={false}>
                      {messages['app.terms.acceptContinue']}
                    </Button>
                  </div>
                  
              </div>
              <div className='orderReport__content'>
                  <Text size="large" tabIndex={0} className="margin-top-10 margin-bottom-20">
                    <FormattedMessage
                      id='app.sepaip.limit.daily.maximum.message'
                      values={{
                        limit: maxSepaTransactionLimit,
                      }}
                    />
                  </Text>
                  <Text size="large" tabIndex={0} className="margin-bottom-20">
                    {messages['app.sepaip.limit.daily.applies.message']}
                  </Text>
                  <Text size="large" tabIndex={0} className="margin-bottom-20">
                    {messages['app.sepaip.limit.lower.daily.message']}
                  </Text>
                  <Text size="large" tabIndex={0}>
                    <FormattedMessage
                      id='app.sepaip.limit.step.one.message'
                      values={{
                        limit: maxSepaTransactionLimit,
                      }}
                    />
                  </Text>
                  <Text size="large" tabIndex={0}>
                    {messages['app.sepaip.limit.step.two.message']}
                  </Text>
                  <Text size="large" tabIndex={0}>
                    {messages['app.sepaip.limit.step.three.message']}
                  </Text>
              </div>
            </div>
  
          </div>
            {isCancelModalVisible && (
              <Modal
                isActive
                header={messages['app.sepaip.limit.modal.title']}
                onClose={this.handleCloseCancelModal}
                className={"model-window-login"}
                content={
                  <div className="padding-20">
                    <Text tabIndex={0}>{messages['app.sepaip.limit.modal.cancel.message']}</Text>
                    <div className='orderReport__modal-actions'>
                      <div className='orderReport__modal-action'>
                        <Button
                          size='large'
                          tertiary
                          fullWidth
                          onPress={this.handleCloseCancelModal}
                        >
                          {messages['app.common.alert.no']}
                        </Button>
                      </div>
                      <div className='orderReport__modal-action'>
                        <Button
                          size='large'
                          fullWidth
                          onPress={this.handleConfirmCancel}
                        >
                          {messages['app.common.alert.yes']}
                        </Button>
                      </div>
                    </div>
                  </div>
                }
              />
            )}
        </React.Fragment>
      );
    }
}

export default createContainer({
  $renderError: () => <Error/>,
  $renderLoading: () => <LoadingCircle isPage={true}/>,
  $queries: {
    sepaLimit: {
      blurModalError: true,
      sepaTransactionLimit: true,
      maxSepaTransactionLimit: true,
      setBlurModalError: { $set: 'blurModalError' },
      saveSepaIpLimit: { $call: 'saveSepaIpLimit' },
      startOtpVerification: { $call: 'startOtpVerification' },
      getSepaIpLimit: { $call: 'getSepaIpLimit' },
      resetOtpState: { $call: 'resetOtpState' },
      isSepaLimitOtpVerified: true,
    },
    changePage: {$call: 'ui.history.push'},
    i18n: {
      messages: true,
    },
  },
})(ManageSepaTransactionLimit);






